import { Trans } from '@lingui/react/macro';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/friends')({ component: FriendsPage });

/** Friends, challenges, invites, group sessions with chat (friends flag). */
function FriendsPage() {
  return (
    <>
      <h1 className="text-headline-md">
        <Trans>Friends</Trans>
      </h1>
      <p className="text-body-md text-on-surface-medium">
        <Trans>Coming soon.</Trans>
      </p>
    </>
  );
}
